import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { useAppSelector } from '../../actions/store';
import { loadEntities, loadEntityType } from '../../actions/entityActions';
import ProductList from './ProductList';
import ConfirmWrapper from './../common/ConfirmWrapper';
import {
    Button,
    Container,
    Dimmer,
    Divider,
    Loader,
    Segment,
} from 'semantic-ui-react';
import { addEntriesToEntities } from '../../utils/EntityUtils';
import PartyWrapper from '../party/Party';
import CheckPermission from '../common/CheckPermission';
import * as uiActions from '../../actions/uiActions';
import { MODAL_COMPONENTS } from '../../constants/modalComponents';

import * as permissionTypes from '../../constants/permissionTypes';
import { orderBy } from 'lodash';
import { useGetFeatures } from '@brallum/vidende/src/utils/Features';
import PartyApi from '../../api/partyApi';
import EntityApi from '../../api/entityApi';
import { ProductInformation } from '../../types';
import toastr from 'toastr';

const ProductsPage = ({ history }) => {
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch();
    const entities = useAppSelector((state) => state.entity.entities);
    const [products, setProducts] = useState<ProductInformation[]>([]);
    const entityType = useAppSelector(
        (state) => state.entity.entityTypes.byId['PRODUCT'],
    );
    const party = useAppSelector((state) => state.currentUser.details.party);

    const fetchProducts = async () => {
        setIsLoading(true);
        try {
            dispatch(
                loadEntities({
                    where: { entityTypeId: 'PRODUCT' },
                    include: ['entries', 'executions', 'entityType'],
                }),
            );
            const res = await EntityApi.getProducts({
                where: {
                    deleted: false,
                },
            });
            setIsLoading(false);
            // Transform the data to include display-friendly archived field for filtering
            const transformedProducts = res.map((product) => ({
                ...product,
                archivedDisplay: product.archived ? 'Archived' : 'Live',
            }));
            setProducts(transformedProducts);
        } catch (error) {
            setIsLoading(false);
            toastr.error(error);
        }
        if (!entityType) dispatch(loadEntityType('PRODUCT'));
    };

    useEffect(() => {
        fetchProducts();
    }, []);

    const handleShowBulkImportModal = () => {
        history.push(`/party/${party.id}/bulkImportEntities/product`);
    };

    const onEntityCreated = () => {
        fetchProducts();
    };

    const handleAddProduct = () => {
        dispatch(
            uiActions.showModal({
                modalType: MODAL_COMPONENTS.CREATE_ENTITY_MODAL,
                modalProps: {
                    partyId: party.id,
                    entityTypeId: 'PRODUCT',
                    onEntityCreated,
                },
            }),
        );
    };
    const handleLaunchGovernanceProgramme = () => {
        dispatch(
            uiActions.showModal({
                modalType: MODAL_COMPONENTS.LAUNCH_GOVERNANCE_PROGRAMME_MODAL,
                modalProps: {
                    mode: 'bulk',
                },
            }),
        );
    };

    const loading = !entityType || isLoading;

    const fields = orderBy(
        entityType?.fields?.filter(
            (field) => field.activityFieldTypeId !== 'Hidden',
        ),
        ['sort'],
    );

    const entitiesWithEntries = addEntriesToEntities(entities, fields);
    //    console.log('entitiesWithEntries', entitiesWithEntries);
    //    console.log('products', products);

    const { VisRiskConsumerDuty } = useGetFeatures();

    return (
        <Container fluid>
            <Dimmer active={loading} inverted>
                <Loader disabled={!loading} />
            </Dimmer>
            <CheckPermission
                structuralNodeId={party.structuralNodeId}
                permissionType={permissionTypes.ADMIN}
            >
                <Segment>
                    <div>
                        {false && (
                            <Button primary onClick={handleShowBulkImportModal}>
                                Bulk import products
                            </Button>
                        )}
                        <Button primary onClick={handleAddProduct}>
                            Add product
                        </Button>

                        {false && (
                            <Button
                                primary
                                onClick={handleLaunchGovernanceProgramme}
                            >
                                Governance Programme
                            </Button>
                        )}
                    </div>
                </Segment>
            </CheckPermission>

            {!loading && (
                <div style={{ overflowX: 'auto' }}>
                    <ProductList
                        //TODO: This needs to source from ProductInformation or PartyProducts
                        fetchProducts={fetchProducts}
                        entities={products}
                        displayedColumns={[
                            'PRODUCT_CLASS', // TODO: Remove this
                            'PRODUCT_REF',
                            'PRODUCT_CARRIER', // TODO: Remove this
                            'PRODUCT_CODE', // TODO: Remove this
                            'PRODUCT_GROUP',
                        ]}
                        hideActionButtons={true}
                    />
                </div>
            )}
        </Container>
    );
};

export default withRouter(ConfirmWrapper(ProductsPage));
